import React, { useState, useEffect } from 'react';
import { educationAPI } from '../../services/api';

const AdminEducation = () => {
  const [education, setEducation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingEdu, setEditingEdu] = useState(null);
  const [formData, setFormData] = useState({
    degree: '',
    institution: '',
    location: '',
    start_year: '',
    end_year: '',
    gpa: '',
  });

  useEffect(() => {
    loadEducation();
  }, []);

  const loadEducation = async () => {
    try {
      const response = await educationAPI.getAll();
      setEducation(response.data);
    } catch (error) {
      console.error('Error loading education:', error);
    }
  };

  const handleAdd = () => {
    setEditingEdu(null);
    setFormData({
      degree: '',
      institution: '',
      location: '',
      start_year: '',
      end_year: '',
      gpa: '',
    });
    setShowModal(true);
  };

  const handleEdit = (edu) => {
    setEditingEdu(edu);
    setFormData({
      degree: edu.degree,
      institution: edu.institution,
      location: edu.location || '',
      start_year: edu.start_year,
      end_year: edu.end_year || '',
      gpa: edu.gpa || '',
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this education entry?')) return;

    try {
      await educationAPI.delete(id);
      loadEducation();
    } catch (error) {
      console.error('Error deleting education:', error);
      alert('Error deleting education');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = {
        degree: formData.degree,
        institution: formData.institution,
        location: formData.location || null,
        start_year: parseInt(formData.start_year),
        end_year: formData.end_year ? parseInt(formData.end_year) : null,
        gpa: formData.gpa || null,
      };

      if (editingEdu) {
        await educationAPI.update(editingEdu.id, data);
      } else {
        await educationAPI.create(data);
      }
      setShowModal(false);
      loadEducation();
    } catch (error) {
      console.error('Error saving education:', error);
      alert('Error saving education');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-gray-800 dark:text-gray-200 text-2xl font-bold mb-4">Education</h2>
        <button className="btn btn-primary" onClick={handleAdd}>Add Education</button>
      </div>

      <div className="item-list">
        {education.map((edu) => (
          <div key={edu.id} className="item-card">
            <div className="item-card-content">
              <h3>{edu.degree}</h3>
              <p><strong>{edu.institution}</strong> {edu.location && `- ${edu.location}`}</p>
              <p>{edu.start_year} - {edu.end_year || 'Present'}</p>
              {edu.gpa && <p><strong>GPA:</strong> {edu.gpa}</p>}
            </div>
            <div className="item-card-actions">
              <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(edu)}>Edit</button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(edu.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingEdu ? 'Edit Education' : 'Add Education'}</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Degree *</label>
                <input
                  type="text"
                  value={formData.degree}
                  onChange={(e) => setFormData({ ...formData, degree: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Institution *</label>
                <input
                  type="text"
                  value={formData.institution}
                  onChange={(e) => setFormData({ ...formData, institution: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Location</label>
                <input
                  type="text"
                  value={formData.location}
                  onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Start Year *</label>
                <input
                  type="number"
                  value={formData.start_year}
                  onChange={(e) => setFormData({ ...formData, start_year: e.target.value })}
                  required
                  min="1900"
                  max="2100"
                />
              </div>
              <div className="form-group">
                <label>End Year</label>
                <input
                  type="number"
                  value={formData.end_year}
                  onChange={(e) => setFormData({ ...formData, end_year: e.target.value })}
                  min="1900"
                  max="2100"
                />
              </div>
              <div className="form-group">
                <label>GPA</label>
                <input
                  type="text"
                  value={formData.gpa}
                  onChange={(e) => setFormData({ ...formData, gpa: e.target.value })}
                  placeholder="e.g., 8.19/10.0"
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminEducation;

